interface Signal5GSVGProps {
  color: string;
  style: React.CSSProperties;
}

const Signal5GSVG = ({ color, style }: Signal5GSVGProps) => (
  <div style={{ display: "flex" }}>
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
    >
      <path
        d="M19.475 30.525C18.7493 29.7995 18.1737 28.9381 17.7809 27.9901C17.3882 27.0422 17.186 26.0261 17.186 25C17.186 23.9738 17.3882 22.9578 17.7809 22.0098C18.1737 21.0618 18.7493 20.2004 19.475 19.475M30.525 19.475C31.2507 20.2004 31.8263 21.0618 32.2191 22.0098C32.6118 22.9578 32.814 23.9738 32.814 25C32.814 26.0261 32.6118 27.0422 32.2191 27.9901C31.8263 28.9381 31.2507 29.7995 30.525 30.525M15.0563 34.9437C13.7504 33.6379 12.7146 32.0876 12.0078 30.3815C11.3011 28.6753 10.9374 26.8467 10.9374 25C10.9374 23.1532 11.3011 21.3246 12.0078 19.6184C12.7146 17.9123 13.7504 16.362 15.0563 15.0562M34.9438 15.0562C36.2496 16.362 37.2854 17.9123 37.9922 19.6184C38.6989 21.3246 39.0626 23.1532 39.0626 25C39.0626 26.8467 38.6989 28.6753 37.9922 30.3815C37.2854 32.0876 36.2496 33.6379 34.9438 34.9437M10.6375 39.3624C2.70417 31.4312 2.70417 18.5708 10.6375 10.6375M39.3625 10.6375C47.2958 18.5687 47.2958 31.4291 39.3625 39.3624M25 25H25.0167V25.0166H25V25ZM25.7812 25C25.7812 25.2072 25.6989 25.4059 25.5524 25.5524C25.4059 25.6989 25.2072 25.7812 25 25.7812C24.7928 25.7812 24.5941 25.6989 24.4476 25.5524C24.3011 25.4059 24.2187 25.2072 24.2187 25C24.2187 24.7928 24.3011 24.594 24.4476 24.4475C24.5941 24.301 24.7928 24.2187 25 24.2187C25.2072 24.2187 25.4059 24.301 25.5524 24.4475C25.6989 24.594 25.7812 24.7928 25.7812 25Z"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18 8H16C15.4696 8 14.9609 8.21071 14.5858 8.58579C14.2107 8.96086 14 9.46957 14 10V14C14 14.5304 14.2107 15.0391 14.5858 15.4142C14.9609 15.7893 15.4696 16 16 16H18V12H17M6 15C6 15.2652 6.10536 15.5196 6.29289 15.7071C6.48043 15.8946 6.73478 16 7 16H9C9.26522 16 9.51957 15.8946 9.70711 15.7071C9.89464 15.5196 10 15.2652 10 15V13C10 12.7348 9.89464 12.4804 9.70711 12.2929C9.51957 12.1054 9.26522 12 9 12H6V8H10"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);

export default Signal5GSVG;
